import React, { lazy } from 'react';
import { motion } from 'framer-motion';
type Shot = {
  src: string;
  alt: string;
  aspect: string;
};
const SHOTS: Shot[] = [{
  src: 'https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&w=900&q=80',
  alt: 'Signature cocktail being garnished',
  aspect: 'aspect-[3/4]'
}, {
  src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=900&q=80',
  alt: 'Plated gourmet small chops',
  aspect: 'aspect-square'
}, {
  src: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=900&q=80',
  alt: 'Private event venue at night',
  aspect: 'aspect-[4/3]'
}, {
  src: 'https://images.unsplash.com/photo-1536935338788-846bb9981813?auto=format&fit=crop&w=900&q=80',
  alt: 'Colorful crafted cocktail on dark bar',
  aspect: 'aspect-[4/5]'
}, {
  src: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=900&q=80',
  alt: 'Bartender pouring a drink in low light',
  aspect: 'aspect-[3/2]'
}, {
  src: 'https://images.unsplash.com/photo-1502301197179-65228ab57f78?auto=format&fit=crop&w=900&q=80',
  alt: 'Assorted appetizers and finger food',
  aspect: 'aspect-square'
}];
export function Gallery() {
  return <section id="gallery" className="w-full max-w-[95%] lg:max-w-[85%] mx-auto border-x border-b border-gridline scroll-mt-24 mb-10 md:mb-20" data-id="element-108">
      <div className="px-8 py-16 md:px-16 md:py-24 border-b border-gridline" data-id="element-109">
        <span className="text-accent font-bold uppercase tracking-[0.35em] text-xs" data-id="element-110">
          The Gallery
        </span>
        <h2 className="mt-4 text-white font-black uppercase tracking-tight text-3xl md:text-5xl" data-id="element-111">
          Moments &amp; Experiences
        </h2>
      </div>

      <div className="p-4 md:p-8" data-id="element-112">
        <div className="columns-2 lg:columns-3 gap-4 md:gap-8 space-y-4 md:space-y-8" data-id="element-113">
          {SHOTS.map((shot, i) => <motion.div key={shot.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: i % 3 * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className={`group relative w-full overflow-hidden border border-white/10 break-inside-avoid ${shot.aspect}`} data-id="element-114">
              <img src={shot.src} alt={shot.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-115" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-6" aria-hidden="true" data-id="element-116">
                <span className="text-white font-bold uppercase tracking-wider text-sm translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-117">
                  {shot.alt}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}